<style lang="less" scoped>
    /deep/ .ivu-input {
        background: radial-gradient(black, transparent);
        color: white;
    }
</style>
<template>
  <div>
    <Poptip trigger="focus">
      <Input
        v-model="searchdata"
        placeholder="请输入..."
        clearable
        style="width: 200px"
        @on-change="changeSearchData(searchdata)"
      />
      <div
        slot="content"
        style="width: 200px;overflow-x:hidden"
      >
        <Menu
          @on-select="goTo"
        >
          <RouterSelectOptions
            v-for="item in cloneList"
            v-show="showHashMap[item.id]"
            :key="item.id"
            :show-hash="showHashMap"
            :options-item="item"
          />
        </menu>
      </div>
    </Poptip>
  </div>
</template>
<script>
    import RouterSelectOptions from './select_router_options';
    import { addShowHash,filtrateShow } from '../../../libs/menus_util'
    import { goFromMenus } from '../../../libs/router_util'
    export default {
        components: { RouterSelectOptions },
        props:{
            list:{
                type: Array,
                default:() => []
            }
        },
        data () {
            return {
                show_hash: {},
                searchdata: ''
            }
        },
        computed: {
            //
            cloneList () {
                addShowHash(this.list,this.show_hash,this.$set)
                return this.list
            },
             showHashMap () {
                if(!this.searchdata.trim()) {
                    // 筛选条件为空时
                    Object.keys(this.show_hash).forEach(id => {
                        this.show_hash[id] = true
                    })
                } else {
                   const selectHashMap = filtrateShow(this.searchdata, this.list)
                    Object.keys(this.show_hash).forEach(id => {
                        this.show_hash[id] = !!selectHashMap[id] // 展示项
                    })
                }
                return this.show_hash
            },
        },
        methods: {
            changeSearchData (data) {
                this.searchdata = data
            },
            goTo (key){
                goFromMenus(key,this.$store.state.menu_id_hash,this.$router)
            },
        }
    }
</script>
